    <template>
    <div id="app">
        <div class="wrapper">
            <div :class="{open: open}" class="sidebar">
                <ul>
                    <li v-for="l in links" :key="l.path">
                        <a :href="l.path">{{ l.name }}</a>
                    </li>
                </ul>
            </div>

            <div :class="{open: open}" class="container">
                <header class="header">
                    <a
                        class="nav-btn"
                        href="#"
                        @click="open = !open"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>

                    <div class="shell">
                        <div class="header__inner">
                            <a href="/" class="logo">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 331.19 96.11" width="246" height="71"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="orange" d="M195.52 3.64A3.64 3.64 0 1 1 191.89 0a3.63 3.63 0 0 1 3.63 3.64zM113 16h4.39v5.93a17 17 0 0 1 4.74-4.79 13.79 13.79 0 0 1 7.05-1.95 11.76 11.76 0 0 1 4.74 1 10.1 10.1 0 0 1 3.67 2.61 14 14 0 0 1 2.41 4.58 16.26 16.26 0 0 1 5.49-6.14 13 13 0 0 1 7.09-2.1 11.07 11.07 0 0 1 6.26 1.8 10.7 10.7 0 0 1 4 5c.88 2.15 1.32 5.36 1.32 9.65v18.76h-4.39V31.6q0-5.52-.79-7.59a6.79 6.79 0 0 0-2.69-3.33 8.13 8.13 0 0 0-4.56-1.27 9.94 9.94 0 0 0-5.88 1.9 10.76 10.76 0 0 0-3.85 5.05c-.83 2.11-1.23 5.62-1.23 10.54v13.45h-4.37V32.77q0-6.23-.78-8.44a7 7 0 0 0-2.7-3.57 7.82 7.82 0 0 0-4.59-1.35 9.93 9.93 0 0 0-5.74 1.85 11 11 0 0 0-4 5c-.85 2.07-1.27 5.27-1.27 9.56v14.53H113zM190 16h4.38v34.4H190zM218.54 16h4.39v5a15.3 15.3 0 0 1 4.29-4.4 8.67 8.67 0 0 1 4.7-1.43 8.17 8.17 0 0 1 3.94 1.17L233.55 20a6.23 6.23 0 0 0-2.35-.6 6.48 6.48 0 0 0-4.3 1.82 11.36 11.36 0 0 0-3.14 5.63q-.84 2.94-.83 11.87v11.63h-4.39zM255.83 16l4.39.06V32a33.54 33.54 0 0 0 .64 8.07 9 9 0 0 0 3.66 5 11.21 11.21 0 0 0 6.48 1.82 11 11 0 0 0 6.34-1.78 9.13 9.13 0 0 0 3.6-4.68q.68-2 .67-8.42V16H286v16.8q0 7.1-1.66 10.69a12.66 12.66 0 0 1-5 5.63 15.82 15.82 0 0 1-8.37 2 16 16 0 0 1-8.41-2 12.55 12.55 0 0 1-5-5.67q-1.65-3.64-1.66-11zM329.83 19.71L327 22.65q-3.54-3.46-6.93-3.47a5.26 5.26 0 0 0-3.69 1.43 4.4 4.4 0 0 0-1.56 3.39 4.9 4.9 0 0 0 1.27 3.2 17.43 17.43 0 0 0 5.3 3.65q4.94 2.58 6.7 4.93a8.92 8.92 0 0 1 1.74 5.38 9.66 9.66 0 0 1-3 7.13 10.09 10.09 0 0 1-7.38 2.92 13.3 13.3 0 0 1-5.65-1.25 12.14 12.14 0 0 1-4.44-3.44l2.78-3.16q3.36 3.81 7.14 3.81a6.38 6.38 0 0 0 4.5-1.72 5.34 5.34 0 0 0 1.85-4 5.16 5.16 0 0 0-1.23-3.4q-1.23-1.45-5.55-3.69c-3.09-1.59-5.2-3.17-6.32-4.72a9 9 0 0 1-1.67-5.33 8.69 8.69 0 0 1 2.66-6.49 9.32 9.32 0 0 1 6.74-2.59q4.74-.09 9.57 4.48zM118.44 64.18a9.24 9.24 0 0 1 3.07.37 3.13 3.13 0 0 1 1.49 1.2 3.3 3.3 0 0 1 .57 1.88 3.45 3.45 0 0 1-.56 1.91 3.27 3.27 0 0 1-1.56 1.25 9.11 9.11 0 0 1-3.09.39h-3.6v-7zm-5.71 18.56h2v-9.55h1.15l7.43 9.55h2.57l-7.43-9.55a10.47 10.47 0 0 0 4.1-.67 4.93 4.93 0 0 0 2.28-1.93 5.46 5.46 0 0 0 .8-3 5.15 5.15 0 0 0-1.16-3.4 5.28 5.28 0 0 0-3-1.8 24.76 24.76 0 0 0-4.67-.28h-4.11zM142.67 62.15h11.74v2h-9.7v6.45h9.6v2h-9.6v8.1h9.6v2h-11.64zM171.75 78.92l1.75-1q1.84 3.38 4.26 3.38a4.06 4.06 0 0 0 1.93-.48 3.4 3.4 0 0 0 1.86-3 3.44 3.44 0 0 0-.7-2 16.71 16.71 0 0 0-3.52-3.3 18.12 18.12 0 0 1-3.19-2.81 5.13 5.13 0 0 1-1.09-3.15 4.77 4.77 0 0 1 .64-2.45 4.53 4.53 0 0 1 1.81-1.74 5.15 5.15 0 0 1 2.54-.64 5.31 5.31 0 0 1 2.72.73 9.17 9.17 0 0 1 2.68 2.67l-1.68 1.27a8.16 8.16 0 0 0-2-2 3.43 3.43 0 0 0-1.8-.49 2.85 2.85 0 0 0-2 .75 2.49 2.49 0 0 0-.8 1.86 3.27 3.27 0 0 0 .28 1.3 4.75 4.75 0 0 0 1 1.37c.27.26 1.16.94 2.67 2.05a14.71 14.71 0 0 1 3.68 3.51 5.57 5.57 0 0 1 1 3.08 5.23 5.23 0 0 1-1.7 3.88 5.7 5.7 0 0 1-4.09 1.53 6.12 6.12 0 0 1-3.4-1 9.32 9.32 0 0 1-2.85-3.32zM201.13 62.15h11.73v2h-9.69v6.45h9.6v2h-9.6v8.1h9.6v2h-11.64zM239.76 74h-7.07l3.54-7.52zM236 62.15l-9.7 20.59h2.25l3.18-6.74h9l3.15 6.71h2.25l-9.6-20.59zM264.58 64.18a9.24 9.24 0 0 1 3.07.37 3.22 3.22 0 0 1 1.49 1.2 3.49 3.49 0 0 1 0 3.79 3.18 3.18 0 0 1-1.56 1.25 9.11 9.11 0 0 1-3.09.39h-3.59v-7zm-5.72 18.56h2v-9.55h1.15l7.42 9.55H272l-7.42-9.55a10.45 10.45 0 0 0 4.09-.67 5 5 0 0 0 2.33-1.93 5.46 5.46 0 0 0 .79-3 5.15 5.15 0 0 0-1.15-3.4 5.35 5.35 0 0 0-3-1.8 24.9 24.9 0 0 0-4.67-.28h-4.12zM304.7 65.93l-1.63 1.24a8.92 8.92 0 0 0-3.22-2.63 9.5 9.5 0 0 0-4.14-.9 9.22 9.22 0 0 0-4.56 1.18 8.49 8.49 0 0 0-3.26 3.18 8.75 8.75 0 0 0-1.15 4.47 8.42 8.42 0 0 0 2.58 6.28 9 9 0 0 0 6.52 2.51 9.17 9.17 0 0 0 7.23-3.38l1.63 1.23a10.41 10.41 0 0 1-3.83 3.06 11.89 11.89 0 0 1-5.12 1.08 10.65 10.65 0 0 1-8.49-3.59 10.84 10.84 0 0 1-2.61-7.33 10.17 10.17 0 0 1 3.16-7.59 10.88 10.88 0 0 1 7.91-3.08 11.9 11.9 0 0 1 5.19 1.12 10 10 0 0 1 3.79 3.15zM316.61 62.15h2v8.59h10.5v-8.58h2v20.58h-2v-9.95h-10.5v9.95h-2z"/><path class="orange" d="M15.34 24.54c.26-.76 1.68-4.53 4.18-4.33s3.86 3.4 4 3.73l10.92 24.65c.68 1.84 1.82 3.69 2.35 3.81s1.56-1.48 2.31-3.25l16.62-34.4a7.64 7.64 0 0 1 6.44-4.59C66.59 10 68.74 14 69 14.48c0 0 17.26 27.21 26.35 41.53a49 49 0 0 0 .66-7.9A48 48 0 1 0 1.85 61.32z"/><path class="orange" d="M62.16 36.94a9.89 9.89 0 0 0-1-1.44 4.19 4.19 0 0 0-1.09 1.24L42.32 66.26c-.42.72-2.67 4.32-5 4.32s-4.05-3.43-4.39-4.22c-.22-.36-13.52-26.46-13.54-26.5a3.17 3.17 0 0 0-.52-.79 1.5 1.5 0 0 0-.35.56L5.74 70.89A48 48 0 0 0 87.08 76z"/></g></g></svg>
                            </a>

                            <nav class="nav">
                                <ul>
                                    <li v-for="l in links" :key="l.path">
                                        <a :href="l.path">{{ l.name }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </header>
                <div class="wrapper__head-margin"><div class="wrapper__half-fill"></div></div>
                <router-view></router-view>
                <section class="section section--dark section--contacts">
                    <div class="shell">
                        <a href="tel:3098283100">309-828-3100</a>
                        <p>Let’s chat about how we can help your business grow.</p>
                    </div>
                </section>
            </div>
            <div class="footer">
                <div class="shell">
                    <div class="footer__inner">
                        <ul>
                            <li>Mirus Research</li>
                            <li>618 E. Lincoln St., Normal, IL 61761   309-828-3100</li>
                            <li>
                                <a href="mailto:questions@mirusresearch.com">
                                    questions@mirusresearch.com
                                </a>
                            </li>
                        </ul>
                        <a href="#" class="logo-small">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" width="72" height="72"><defs></defs><title>logo-footer</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="darkgrey" d="M15.34,24.43c.26-.76,1.68-4.53,4.18-4.34s3.86,3.4,4,3.73L34.44,48.47v0c.68,1.84,1.82,3.69,2.35,3.8s1.56-1.47,2.31-3.24L55.72,14.63a7.63,7.63,0,0,1,6.44-4.58c4.43-.2,6.58,3.83,6.83,4.32L95.34,55.9A49,49,0,0,0,96,48,48,48,0,1,0,1.85,61.2Z"/><path class="darkgrey" d="M62.16,36.82l0,0a10.07,10.07,0,0,0-1-1.45,4.47,4.47,0,0,0-1.09,1.24L42.32,66.15c-.42.72-2.67,4.32-5,4.32S33.22,67,32.88,66.25L19.39,39.74a3.37,3.37,0,0,0-.52-.79,1.68,1.68,0,0,0-.35.56L5.74,70.77a48,48,0,0,0,81.34,5.08Z"/></g></g></svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'app',
    data() {
        return {
            links: [
                {
                    name: 'Our Services',
                    path: '/services',
                },
                {
                    name: 'Our Work',
                    path: '/work',
                },
                {
                    name: 'Careers',
                    path: '/careers',
                },
                {
                    name: 'About Us',
                    path: '/about',
                },
                {
                    name: 'Lonely?',
                    path: '/contact',
                },
            ],
            open: false,
        };
    },
};
</script>
<style lang="scss">
$HEADGLOW : rgba(0,0,0,0.3);
/* ------------------------------------------------------------ *\
	Header
\* ------------------------------------------------------------ */

.header {
    padding-top: 30px;
}

.header .logo {
    // svg {
        // -webkit-filter: drop-shadow(0px 0px 8px $HEADGLOW);
        // filter: drop-shadow(0px 0px 8px $HEADGLOW);
    // }
    float: left;
    -webkit-transition: margin 0.3s;
    -o-transition: margin 0.3s;
    transition: margin 0.3s;
}

.header .logo .orange {
    // fill: #f58220;
    fill: #090909;
}

.header .nav {
    float: right;
    margin-top: 27px;
}

.header .header__inner:after {
    content: '';
    clear: both;
    display: table;
    line-height: 0;
}

@media (max-width: 991px) {
    .header .logo svg {
        width: 174px;
        height: 51px;
        margin-bottom:20px;
    }
    .header .nav {
        margin-top: 14px;
    }
}

@media (max-width: 767px) {
    .header {
        position: relative;
        padding: 30px 0 12px;
        text-align: center;
    }

    .header .logo {
        float: right;
    }
    .header .nav {
        display: none;
    }
}

/* ------------------------------------------------------------ *\
	Nav
\* ------------------------------------------------------------ */

.nav {
    position: relative;
}

.nav li {
    float: left;
}

.nav li + li {
    margin-left: 27px;
}

.nav li.current a {
    color: #313131;
}

.nav li.current a:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20px;
    background: #df6326;
    z-index: 2;
}

.nav a {
    display: block;
    position: relative;
    padding-bottom: 54px;
    text-decoration: none;
    color: #e16426;
    font-weight: 700;
    -webkit-transition: color 0.3s;
    -o-transition: color 0.3s;
    transition: color 0.3s;
}

.nav a:hover {
    color: #313131;
}

@media (max-width: 991px) {
    .nav a {
        font-size: 16px;
        padding-bottom: 14px;
    }
}

/* ------------------------------------------------------------ *\
	Nav Btn
\* ------------------------------------------------------------ */

.nav-btn {
    display: none;
    position: absolute;
    top: 42px;
    left: 21px;
    z-index: 200;
    width: 30px;
    height: 23px;
    margin: auto;
}

.nav-btn span {
    display: block;
    position: absolute;
    left: 0;
    height: 3px;
    background: #313131;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-transform: 0.2s 0s;
    -ms-transform: 0.2s 0s;
    transform: 0.2s 0s;
}

.nav-btn span:nth-child(1) {
    top: 0px;
    width: 30px;
}

.nav-btn span:nth-child(2) {
    top: 10px;
    width: 24px;
}

.nav-btn span:nth-child(3) {
    top: 20px;
    width: 18px;
}

.nav-btn.active span {
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
}

.nav-btn.active span:nth-child(2) {
    opacity: 0;
}

.nav-btn.active span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.nav-btn.active span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.nav-btn.active span:nth-child(3),
.nav-btn.active span:nth-child(1) {
    top: 5px;
}

@media (max-width: 767px) {
    .nav-btn {
        display: block;
    }

    .nav-btn.active span:nth-child(3),
    .nav-btn.active span:nth-child(1) {
        top: 10px;
        width: 30px;
    }
}
/* ------------------------------------------------------------ *\
	Sidebar
\* ------------------------------------------------------------ */

.sidebar {
    display: none;
}

@media (max-width: 767px) {
    .sidebar {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 227px;
        padding: 30px 0 30px 42px;
        background: #f58220;
        z-index: 300;
        -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
        transform: translateX(-100%);
        -webkit-transition: -webkit-transform 0.3s;
        transition: -webkit-transform 0.3s;
        -o-transition: transform 0.3s;
        transition: transform 0.3s;
        transition: transform 0.3s, -webkit-transform 0.3s;
    }
    .sidebar.open {
        -webkit-transform: translateX(0%);
        -ms-transform: translateX(0%);
        transform: translateX(0%);
    }
    .sidebar ul {
        color: #fff;
        text-decoration: none;
        list-style-type: none;
        font-size: 20px;
        font-weight: 700;
    }
    .sidebar ul a {
        text-decoration: none;
    }
    .sidebar li + li {
        margin-top: 24px;
    }
}
/* ------------------------------------------------------------ *\
	Footer
\* ------------------------------------------------------------ */

.footer {
    padding: 57px 0;
}

.footer ul {
    list-style-type: none;
    text-align: right;
    margin-bottom: 0;
}

.footer ul a {
    color: #df6326;
    text-decoration: none;
    -webkit-transition: color 0.3s;
    -o-transition: color 0.3s;
    transition: color 0.3s;
}

.footer ul a:hover {
    color: #313131;
}

.footer .footer__inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    float: right;
}

.footer .footer__inner:after {
    content: '';
    clear: both;
    display: table;
    line-height: 0;
}

.footer .logo-small {
    margin-left: 27px;
}

.footer .logo-small .darkgrey {
    fill: #313131;
}

@media (max-width: 767px) {
    .footer {
        padding: 36px 0;
    }

    .footer ul {
        width: 100%;
        text-align: center;
        font-size: 17px;
    }

    .footer .footer__inner {
        float: none;
        -webkit-box-orient: vertical;
        -webkit-box-direction: reverse;
        -ms-flex-direction: column-reverse;
        flex-direction: column-reverse;
        text-align: center;
    }

    .footer .logo-small {
        display: inline-block;
        margin: 0 0 8px;
    }
}


</style>
